import {
  all,
  call,
  takeEvery,
  fork,
  put,
  takeLatest,
} from "redux-saga/effects";
import actions from "./actions";
import * as programmingActions from "../programming/actions";
import { fetchExercisesSuccess } from "./actions";
import contactActions from "./actions";
import { getToken, clearToken } from "../../helpers/utility";
import * as requests from "../../helpers/requests";

import { store } from "../store";

import config from "../../config";

export function* addContact() {
  yield takeEvery(actions.ADD_CONTACT, function*() {});
}
export function* editContact() {
  yield takeEvery(actions.EDIT_CONTACT, function*() {});
}
export function* deleteContact() {
  yield takeEvery(actions.DELETE__CONTACT, function*() {});
}
// export default function* rootSaga() {
//   yield all([fork(addContact), fork(editContact), fork(deleteContact)]);
// }

const fetchExercises = (url) => {
  return requests.get(url);
};

const postExercise = (url, exercise) => {
  return requests.post(url, JSON.stringify(exercise));
};

const patchExercise = (url, exercise) => {
  return requests.patch(url, JSON.stringify(exercise));
};

export function* watchLoadExercises() {
  // console.log("calling watch load exercises");
  const url = config.api_url + `/webapi/v1/exercise_partial/?core=true`;
  try {
    const response = yield call(fetchExercises, url);
    yield put(fetchExercisesSuccess(response));
    // console.log(response);
    return response;
  } catch (e) {
    console.log(e);
    return;
  }
}

export function* fetchExerciseLogsNotMatching() {
  let url = `${config.api_url}/webapi/v1/exercise_log_not_matching_corelib/`;
  let payload = yield call(requests.get, url);
  yield put({ type: "NOT_MATCHING_EX_LOGS_LOAD", payload });
}

export function* saveExercise1(payload) {
  const url = config.api_url + `/webapi/exercise/`;
  // return fetch(url).then(res => res.json())

  let token = getToken().get("token");

  return fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload.exercise),
    //body: "{}" //needs this or bombs on no json obj to be decoded (probably should fix in django)
  }).then((res) => res.json());

  return;
}

function* createExercise(action) {
  console.log("in create exercise saga");
  const url = `${config.api_url}/webapi/v1/exercise/`;
  const response = yield call(
    requests.post,
    url,
    JSON.stringify(action.payload)
  );

  console.log("new createexercise response is:", response);
  yield call(watchLoadExercises);
  yield put(programmingActions.hideCreateExerciseModal());
}

function* updateExercise(action) {
  //we'll handle the patch call locally instead
  // const url = `${config.api_url}/webapi/v1/exercise/${action.payload.id}/`;
  // const response = yield call(
  //   requests.patch,
  //   url,
  //   JSON.stringify(action.payload)
  // );
  yield call(watchLoadExercises);
  yield put(programmingActions.hideEditExerciseModal());
  yield put({ type: "SELECT_EXERCISE", payload: action.payload });
}

function* deleteExercise(action) {
  const url = `${config.api_url}/webapi/v1/exercise/${
    action.payload.exercise
  }/`;
  const response = yield call(requests._delete, url);
  yield put(contactActions.removeExercise(action.payload.exercise));
}

function* hideExReplacementLog(action) {
  let { not_matching_ex_logs } = store.getState().Exercises;
  let ex = action.payload;
  let url = `${config.api_url}/webapi/v1/exercise_log_replacement/`;

  let to_patch = not_matching_ex_logs.filter((e) => e.name === ex.name);

  for (let item of to_patch) {
    console.log("posting patch for item", item);
    let data = {
      name: ex.name,
      user: ex.user_id,
      exercise_log: item.uuid,
      hidden: true,
    };
    yield call(requests.post, url, JSON.stringify(data));
  }

  not_matching_ex_logs = not_matching_ex_logs.map((e) => {
    if (e.name === ex.name) {
      e.exercise_log_replacement_record = [{ hidden: true }];
    }
    return e;
  });
  yield put({
    type: "NOT_MATCHING_EX_LOGS_LOAD",
    payload: not_matching_ex_logs,
  });
}

function* replaceExReplacementLog(action) {
  let { not_matching_ex_logs, selectedExercise } = store.getState().Exercises;
  let ex = action.payload;
  let url = `${config.api_url}/webapi/v1/exercise_log_replacement/`;

  let to_patch = not_matching_ex_logs.filter(
    (e) => !!(e.name === ex.name && e.user.id === ex.user_id)
  );

  for (let item of to_patch) {
    console.log("posting patch for item", item);
    let data = {
      name: ex.name,
      replacement: selectedExercise.id,
      user: ex.user_id,
      exercise_log: item.uuid,
      hidden: true,
    };
    yield call(requests.post, url, JSON.stringify(data));
  }

  not_matching_ex_logs = not_matching_ex_logs.map((e) => {
    if (e.name === ex.name) {
      e.exercise_log_replacement_record = [{ hidden: true }];
    }
    return e;
  });
  yield put({
    type: "NOT_MATCHING_EX_LOGS_LOAD",
    payload: not_matching_ex_logs,
  });
}

export default function* exercisesSagaWatcher() {
  yield all([
    takeLatest(actions.FETCH_EXERCISES, watchLoadExercises),
    takeLatest(actions.SAVE_EXERCISES, saveExercise1),
    takeEvery(actions.CREATE_EXERCISE, createExercise),
    takeEvery(actions.UPDATE_EXERCISE, updateExercise),
    // takeEvery(actions.DELETE_EXERCISE, deleteExercise),
    takeEvery(
      actions.FETCH_EXERCISE_LOGS_NOT_MATCHING,
      fetchExerciseLogsNotMatching
    ),
    takeEvery(actions.HIDE_EX_REPLACEMENT_LOG, hideExReplacementLog),
    takeEvery(actions.REPLACE_EX_REPLACEMENT_LOG, replaceExReplacementLog),
  ]);
}
